<template>
  <v-layout wrap class="container px-2 py-0">
    <router-view />
  </v-layout>
</template>

<script>
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  name: 'DtpPage',
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('car_accident_view', next);
  },
};
</script>

<style></style>
